import SEO from '@/components/shared/SEO';
import { heroImages } from '@/data/images';

export default function TermsOfService() {
  return (
    <div data-testid="terms-page">
      <SEO
        title="Terms of Service"
        description="Review Trademark Pact's terms of service governing the use of our trademark registration, intellectual property, and corporate services."
      />
      <section className="relative pt-28 pb-12 lg:pt-36 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img src={heroImages.terms} alt="" className="w-full h-full object-cover" loading="eager" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#064E3B]/95 via-[#064E3B]/85 to-[#064E3B]/70" />
        </div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <h1 className="font-heading font-extrabold text-4xl sm:text-5xl text-white tracking-tight mb-4">Terms of Service</h1>
          <p className="text-emerald-200 text-sm">Last updated: January 2025</p>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate max-w-none">
          <div className="space-y-8 text-sm text-slate-600 leading-relaxed">
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Agreement to Terms</h2>
              <p>By accessing or using the services provided by Trademark Pact, you agree to be bound by these Terms of Service. If you do not agree to these terms, you may not access or use our services. These Terms constitute a legally binding agreement between you and Trademark Pact.</p>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Services Description</h2>
              <p>Trademark Pact provides trademark registration, intellectual property services, company formation, and related legal and business services. Our services include, but are not limited to, trademark searches, application filing, office action responses, monitoring services, copyright registration, patent services, and corporate formation and compliance services.</p>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">User Responsibilities</h2>
              <p className="mb-3">By using our services, you agree to:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Provide accurate and complete information as requested</li>
                <li>Maintain the confidentiality of your account credentials</li>
                <li>Notify us promptly of any unauthorized use of your account</li>
                <li>Use our services only for lawful purposes</li>
                <li>Not interfere with the proper functioning of our website or services</li>
                <li>Comply with all applicable laws and regulations</li>
              </ul>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Fees and Payment</h2>
              <p>Service fees are as listed on our website and may be subject to change. Government filing fees are separate from our service fees and are the responsibility of the client. Payment is required before services commence unless otherwise agreed. All fees are non-refundable except as expressly stated in our refund policy.</p>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Intellectual Property</h2>
              <p>All content, trademarks, logos, and intellectual property displayed on our website are the property of Trademark Pact or our licensors. You may not reproduce, distribute, modify, or create derivative works of any content on our website without our prior written consent.</p>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Limitation of Liability</h2>
              <p>To the fullest extent permitted by law, Trademark Pact shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from or related to your use of our services. Our total liability shall not exceed the amount you paid for the specific service giving rise to the claim.</p>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Disclaimer of Warranties</h2>
              <p>Our services are provided on an "as is" and "as available" basis without warranties of any kind, either express or implied. While we strive for the best possible outcomes, we cannot guarantee the approval of any trademark application or the outcome of any legal proceeding.</p>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Termination</h2>
              <p>We reserve the right to terminate or suspend your access to our services at our sole discretion, without notice, for any reason, including but not limited to a breach of these Terms. Upon termination, your right to use our services will immediately cease.</p>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Governing Law</h2>
              <p>These Terms shall be governed by and construed in accordance with the laws of the United States. Any disputes arising from these Terms or your use of our services shall be resolved through binding arbitration or in the courts of competent jurisdiction.</p>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Changes to Terms</h2>
              <p>We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting on our website. Your continued use of our services after any modifications constitutes your acceptance of the revised Terms.</p>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Contact Information</h2>
              <p>For questions regarding these Terms of Service, please contact us at info@trademarkpact.com.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
